<template>
  <div class="loader-container">
    <h1>Profile</h1>
    <div>{{ session.user.firstName }} {{ session.user.lastName }}</div>
    <div>{{ session.user.email }}</div>
    <button class="ui-button" type="button" @click="viewProfile">
      View Full
    </button>
    <button class="ui-button" type="button" @click="logout">Logout</button>
    <button class="ui-button" type="button" @click="clearCache">
      Clear Cache
    </button>
    <ModalIFrame
      :visible="showModal"
      :url="profileUrl"
      @close="showModal = false"
    />
    <Loader :loading="loading" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Service from '@/services/Service.js';
import ModalIFrame from '@/components/ModalIFrame.vue';
import Loader from '@/components/Loader';
export default {
  components: { ModalIFrame, Loader },
  data: function() {
    return {
      showModal: false,
      loading: false
    };
  },
  computed: {
    profileUrl() {
      return (
        process.env.VUE_APP_SALES_URL +
        '/profile/default.aspx?sessionid=' +
        this.session.id +
        '&theme=Stark_V'
      );
    },
    ...mapState(['session'])
  },
  methods: {
    logout() {
      return Service.logout().then(() => {
        this.$store.dispatch('logout').catch(error => {
          console.log(error.response);
        });
      });
    },
    viewProfile() {
      this.showModal = true;
    },
    clearCache() {
      self.loading = true;
      return Service.clearCache()
        .then(() => {
          this.$store.dispatch('addMessage', {
            message: 'Cache Cleared',
            timeout: 3000
          });
          self.loading = false;
        })
        .catch(error => {
          this.$store.dispatch('addMessage', {
            message: 'Error clearing cache'
          });
          console.log(error);
        });
    }
  }
};
</script>
